import { render, staticRenderFns } from "./roomTemporary.vue?vue&type=template&id=045745aa&"
import script from "./roomTemporary.vue?vue&type=script&lang=js&"
export * from "./roomTemporary.vue?vue&type=script&lang=js&"
import style0 from "./roomTemporary.vue?vue&type=style&index=0&id=045745aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports